export const makeAccountsList = (response, getIcon) => {
    const mapAccount = (account) => {
        const { title, guid, integration, currency, current_balance: currentBalance } = account;

        return {
            title,
            value: guid,
            account,
            icon: integration && getIcon ? getIcon(account) : '',
            balance: {
                'current_balance': currentBalance,
                sign: currency.sign,
            },
        };
    };

    const accountsList = response.data
        .filter((account) => account.is_archive === false)
        .map(mapAccount);

    const accountsListArchive = response.data
        .filter((account) => account.is_archive === true)
        .map(mapAccount);

    return { accountsList, accountsListArchive };
};
